import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductFruits } from 'react-product-fruits'
import { useSelector } from 'react-redux'
import Config from '../config'

function ProductFruitsWrapper() {
  const { i18n } = useTranslation()
  const ssoUser = useSelector(state => state.auth.ssoUser)
  const profile = useSelector(state => state.auth.profile)

  if (!Config.productFruits.enabled || !ssoUser || !profile) {
    return null
  }

  const language = i18n.language?.toLowerCase().substring(0, 2) || 'en'

  return (
    <ProductFruits
      workspaceCode={Config.productFruits.workspaceCode}
      language={language}
      user={{
        username: profile.email,
        email: profile.email,
        firstname: profile.first_name,
        lastname: profile.last_name,
        props: {
          user_id: profile.id,
        },
      }}
      lifeCycle='neverUnmount'
    />
  )
}

export default ProductFruitsWrapper
